import React from 'react';
import { useIntl, getLocale } from 'umi';
import { Table, Card, StatusTip } from 'tea-component';
import { LANGUAGE_CN } from '@/pages/intelligence/_config/config';
import './index.scss';

import type { IBaseProps } from '@/pages/intelligence/types/common';

const { LoadingTip } = StatusTip;

interface ITableStateProps extends IBaseProps {
  loadingText?: string;
  emptyText?: string;
  state?: string;
  columns?: Array<any>;
  onRefresh?: Function;
  height?: number;
}

export const TABLE_STATE = {
  LOADING: '1',
  EMPTY: '2',
  ERROR: '3',
};

const TableState: React.FC<ITableStateProps> = (props) => {
  const { formatMessage } = useIntl();
  const locale = getLocale();
  const {
    height = 200,
    loadingText = formatMessage({ id: 'common_loading' }),
    emptyText = formatMessage({ id: 'common_nodata' }),
    state,
    columns = [],
    onRefresh,
  } = props;

  const handleRefresh = () => {
    onRefresh?.();
  };

  const renderState = () => {
    if (state === TABLE_STATE.LOADING) return <LoadingTip loadingText={loadingText} />;
    if (state === TABLE_STATE.EMPTY) return <div className="table-state">{emptyText}</div>;
    if (state === TABLE_STATE.ERROR)
      return (
        <div className="table-state">
          {locale === LANGUAGE_CN ? (
            <>
              加载失败. <a onClick={handleRefresh}>刷新</a>
            </>
          ) : (
            <>
              Loading failed. Please <a onClick={handleRefresh}>refresh</a>
            </>
          )}
        </div>
      );
  };

  return (
    <div className="dbi-mobile-global-compare-table-loading">
      <Card style={{ marginBottom: 20, height, textAlign: 'center' }}>
        <Card.Body style={{ height: '100%' }}>
          <div className="table-loading-main">
            <Table records={[]} columns={columns} />
            {renderState()}
          </div>
        </Card.Body>
      </Card>
    </div>
  );
};

export default TableState;
